<template>
  <div class="language-selector">
    <label for="language" class="label">Sprache wählen:</label>
    <select id="language" v-model="selectedLanguage" @change="handleChange">
      <option disabled value="">Bitte auswählen</option>

      <!-- Priorisierte Sprachen -->
      <optgroup label="Beliebte Sprachen">
        <option v-for="lang in prioritizedLanguages" :key="lang" :value="lang">
          {{ lang }}
        </option>
      </optgroup>

      <!-- Alle übrigen Sprachen -->
      <optgroup label="Weitere Sprachen">
        <option v-for="lang in otherLanguages" :key="lang" :value="lang">
          {{ lang }}
        </option>
      </optgroup>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SprachAuswahl',
  data() {
    return {
      selectedLanguage: '',
      prioritizedLanguages: [
        'Deutsch', 'Englisch', 'Französisch', 'Italienisch', 'Spanisch', 'Türkisch'
      ],
      otherLanguages: [
        'Afrikaans', 'Arabisch', 'Aserbaidschanisch', 'Bengalisch', 'Birmanisch (Myanmar)',
        'Chinesisch (vereinfacht)', 'Estnisch', 'Finnisch', 'Galicisch', 'Georgisch',
        'Gujarati', 'Hebräisch', 'Hindi', 'Indonesisch', 'Japanisch', 'Kasachisch',
        'Khmer', 'Koreanisch', 'Kroatisch', 'Lettisch', 'Litauisch', 'Malayalam',
        'Marathi', 'Mazedonisch', 'Mongolisch', 'Nepalesisch', 'Niederländisch',
        'Paschtu', 'Persisch', 'Polnisch', 'Portugiesisch', 'Rumänisch', 'Russisch',
        'Schwedisch', 'Singhalesisch', 'Slowenisch', 'Swahili', 'Tagalog', 'Tamil',
        'Telugu', 'Thai', 'Tschechisch', 'Ukrainisch', 'Urdu', 'Vietnamesisch', 'Xhosa'
      ]
    }
  },
  methods: {
    handleChange() {
      this.$emit('sprache-gewaehlt', this.selectedLanguage)
      console.log(`Gewählte Sprache: ${this.selectedLanguage}`)
    }
  }
}
</script>

<style scoped>
.language-selector {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  max-width: 340px;
  margin: 0 auto;
  font-family: system-ui, -apple-system, sans-serif;
}

.label {
  font-weight: 700;
  font-size: 1rem;
  color: #222;
}

select {
  width: 100%;
  padding: 10px 14px;
  font-size: 1rem;
  border: 2px solid #000;
  border-radius: 10px;
  background-color: #fff;
  cursor: pointer;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

select:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.12);
}

select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0,123,255,0.25);
}

optgroup {
  font-weight: bold;
  color: #333;
  padding-top: 4px;
}
</style>
